module.exports = __webpack_public_path__ + "static/media/webgestor_login_bg.af488fdd.jpg";